"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildDynamicValidationSchema = exports.validationSchema = void 0;

var _yup = require("yup");

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
var validationSchema = (0, _yup.object)().shape({
  option: (0, _yup.string)().label('The options').trim().required('The options needs to be filled in.').max(255)
});
exports.validationSchema = validationSchema;

var buildDynamicValidationSchema = function buildDynamicValidationSchema(options) {
  var rules = options.reduce(function (acc, name) {
    acc[name] = (0, _yup.string)().trim().required("This field needs to be filled in.");
    return acc;
  }, {});
  return (0, _yup.object)().shape(rules);
};

exports.buildDynamicValidationSchema = buildDynamicValidationSchema;